module.exports = __webpack_public_path__ + "img/vip_badge_1.de4d3a7b.png";